import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { change } from 'redux-form'
import { getFormFieldsConfig, getHiddenFieldsInitialValues } from './selector'
import { CTA_FORM_NAMES } from 'LiveBoard/components/shared/CallToAction/types/forms/constants'
import { validateCustomForm } from './Form/validator'
import { FormWrapperContainer, CustomFormFields } from './Form'
import get from 'lodash/get'
import map from 'lodash/map'

class CustomFormContainer extends React.Component {

  componentDidMount() {
    map(this.props.hiddenFieldsValues, (value, key) => {
      this.props.change(this.props.form, key, value)
    })

    const customEvent = new CustomEvent(
      "follozeFormLoaded",
      {
        detail: {
          setFieldValue: this.setHiddenFieldValue,
          formName: this.props.config.form.form_name
        }
      }
    )
    window.dispatchEvent(customEvent)
  }

  setHiddenFieldValue = (fieldName, value) => {
    const formFieldsNames = Object.keys(this.props.fields)
    if (formFieldsNames.includes(fieldName)) {
      this.props.change(this.props.form, fieldName, value)
    }
  }

  handleSubmit = (values) => {
    const successMessage = this.props.config.form.success_message
    const redirectUrl = this.props.config.form.submit_redirect_url

    this.props.onSubmit(
      values,
      Object.keys(this.props.fields),
      successMessage,
      redirectUrl
    )
  }

  validate = (values, checkboxesConfig) => {
    return validateCustomForm({
      values,
      form: CTA_FORM_NAMES.customForm,
      privacyMessageCheckboxConfig: checkboxesConfig,
      fields: this.props.fields
    })
  }

  render = () => {
    const hasCustomTemplate = this.props.config.form.is_template

    let config = { ...this.props.config }
    if (hasCustomTemplate) {
      config.privacy_message = get(this.props.config, 'form.privacy_message')
    }

    return (
      <FormWrapperContainer
        config={config}
        area={this.props.area}
        onSubmit={this.handleSubmit}
        customValidation={this.validate}
        title={config.form.form_title}
        submitBtnLabel={config.form.submit_label}
        successMessage={config.form.submit_label}
        itemId={this.props.itemId}
        ctaClass={this.props.ctaClass}
        form={this.props.form} >
          <CustomFormFields fields={this.props.fields} shouldTranslate={!hasCustomTemplate}/>
        </FormWrapperContainer>
    )
  }
}

CustomFormContainer.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  itemId: PropTypes.number,
  ctaClass: PropTypes.string,
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired
}

CustomFormContainer.defaultProps = {
  itemId: 0,
  ctaClass: ''
}

function mapStateToProps(state, props) {
  const fields = getFormFieldsConfig(state, props)
  const hiddenFieldsValues = getHiddenFieldsInitialValues(state, props)

  return {
    fields,
    hiddenFieldsValues
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ change }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomFormContainer)